import React from 'react';
import { Link } from 'react-router-dom';
import './HomeServices.css';

const HomeServices = () => {
    const services = [
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M9 11H5a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h4"></path>
                    <path d="M15 11h4a2 2 0 0 1 2 2v3c0 1.1-.9 2-2 2h-4"></path>
                    <path d="M9 7h6v4H9z"></path>
                    <path d="M9 3h6v4H9z"></path>
                </svg>
            ),
            title: 'MAP Compliance',
            description:
                'Automated pricing enforcement with zero tolerance for violations.',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M9 12l2 2 4-4"></path>
                    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"></path>
                </svg>
            ),
            title: 'Authorized Seller',
            description:
                'Verified documentation with full brand authorization.',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                </svg>
            ),
            title: 'Fast Operations',
            description: 'Same-day processing with premium fulfillment.',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                </svg>
            ),
            title: 'Data-Driven Advertising',
            description:
                'We run effective ad campaigns on Amazon, Meta, and Google to scale your business.',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="M21 21l-4.35-4.35"></path>
                </svg>
            ),
            title: 'Competitive Insights',
            description:
                'Analyze your market with tools like Keepa and Helium10.',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9,22 9,12 15,12 15,22"></polyline>
                </svg>
            ),
            title: 'Multi-Channel Sales',
            description:
                'Reach more customers on Amazon, Walmart, Shopify, and other top platforms.',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                </svg>
            ),
            title: 'Inventory Management',
            description:
                'We handle storage, prep, and shipments from our US-based warehouse.',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                </svg>
            ),
            title: 'Ad Investment',
            description:
                'We allocate advertising budgets on your behalf across Amazon, Meta, and Google.',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                </svg>
            ),
            title: 'A+ Content & Optimization',
            description:
                'We enhance listings with high-converting visuals and backend SEO.',
        },
    ];

    return (
        <section className="home-services section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">
                        <span className="services-title-text">Our </span>
                        <span className="services-title-highlight">
                            Services
                        </span>
                    </h2>
                    <p className="section-subtitle">
                        Avenis is your new avenue to smarter selling. Inventory,
                        compliance, and marketing handled. You focus on your
                        product; we scale your sales. Authorized retail partner
                        delivering MAP-compliant, brand-safe e-commerce
                        solutions with complete transparency and
                        enterprise-grade protection.
                    </p>
                </div>

                <div className="home-services-grid">
                    {services.map((service, index) => (
                        <div key={index} className="home-service-card">
                            <div className="home-service-card-bg"></div>
                            <div
                                className={`home-service-icon home-service-icon-${
                                    index + 1
                                }`}
                            >
                                {service.icon}
                            </div>
                            <h3 className="home-service-title">
                                {service.title}
                            </h3>
                            <p className="home-service-description">
                                {service.description}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="home-services-cta">
                    <Link
                        to="/services"
                        className="btn btn-primary"
                        onClick={() => window.scrollTo(0, 0)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M9 18l6-6-6-6"></path>
                        </svg>
                        View All Services
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default HomeServices;
